export const donBaseURL = 'https://mastodon.compositecomputer.club';
// export const donBaseURL = process.env.MASTODON_BASE_URL
export const donWSURL = 'wss://mastodon.compositecomputer.club/api/v1/streaming';
// export const donWSURL = process.env.MASTODON_WS_URL
export const donClientID = 'G8c8kVAQreVUz7at4FGaXUrzVJP-A8-JCCigVaOfWvY';
// export const donClientID = process.env.MASTODON_CLIENT_ID
export const donClientSecret = 'TiwysIO4EJ91Qj01yZSF3Oz8H_efLA40T9RYr-kVpkQ';
// export const donClientSecret = process.env.MASTODON_CLIENT_SECRET
export const redirectURL = `${location.protocol}//${location.host}`;
// export const redirectURL = process.env.REDIRECT_URL
